var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-navigation" },
    [
      _c("div", { staticClass: "mobile-menu__service-txt" }, [
        _c("div", { staticClass: "mobile-menu__service-txt--1" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.$translate("TuningFanatics::Template.expressService")
              ) + " "
            )
          ]),
          _vm._v(_vm._s(_vm.$translate("TuningFanatics::Template.phoneNumber")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-menu__service-txt--2" }, [
          _vm._v(
            _vm._s(_vm.$translate("TuningFanatics::Template.openingHours"))
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized"
            }
          ]
        },
        [
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" }
            },
            [
              _vm.dataContainer1.parent && _vm.dataContainer1.parent.id !== 659
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer1.parent &&
                              _vm.dataContainer1.parent.parent) ||
                              null,
                            true
                          )
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "nav-direction btn-up" }, [
                        _c("i", {
                          staticClass: "fa fa-angle-left",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.homepageBack")
                            ) +
                            "\n                "
                        )
                      ])
                    ]
                  )
                : _c("li", { staticClass: "cat-headline" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("TuningFanatics::Template.catHeadline")
                      ) + ":"
                    )
                  ]),
              _vm._v(" "),
              _vm.dataContainer1.parent && _vm.dataContainer1.parent.id !== 659
                ? _c("li", { staticClass: "ddown" }, [
                    _c("a", { attrs: { href: _vm.parentUrl } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("TuningFanatics::Template.allProducts")
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer1.categories, function(category) {
                return _c(
                  "li",
                  {
                    staticClass: "ddown",
                    on: {
                      click: function($event) {
                        return _vm.slideTo(category)
                      }
                    }
                  },
                  [
                    _c("a", [_vm._v(_vm._s(category.details[0].name))]),
                    _vm._v(" "),
                    category.childCount
                      ? _c("span", { staticClass: "nav-direction" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "11",
                                height: "11"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M10.131 4.958a.556.556 0 0 1 .162.426.54.54 0 0 1-.162.408L5.427 10.08a.568.568 0 0 1-.79-.004.56.56 0 0 1 0-.795L8.92 5.375l-4.28-3.9a.56.56 0 0 1-.005-.8.565.565 0 0 1 .796.001l4.699 4.282zm-4.31.425a.538.538 0 0 1-.16.409L.955 10.079A.566.566 0 0 1 0 9.677c0-.15.06-.29.166-.397L4.45 5.375.17 1.475a.558.558 0 0 1-.005-.8.564.564 0 0 1 .795.001l4.7 4.282a.557.557 0 0 1 .16.425z",
                                  fill: "#31313a",
                                  "fill-rule": "evenodd"
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              }),
              _vm._v(" "),
              _vm.dataContainer1.categories[0]
                ? _vm._l(
                    _vm.dataContainer1.categories[0].siblingCount -
                      _vm.dataContainer1.categories.length,
                    function(number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" }
                        })
                      ])
                    }
                  )
                : _vm.dataContainer1.parent
                ? _vm._l(_vm.dataContainer1.parent.childCount, function(
                    number
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0",
              attrs: { id: "menu-2" }
            },
            [
              _vm.dataContainer2.parent && _vm.dataContainer2.parent.id !== 659
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer2.parent &&
                              _vm.dataContainer2.parent.parent) ||
                              null,
                            true
                          )
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "nav-direction btn-up" }, [
                        _c("i", {
                          staticClass: "fa fa-angle-left",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.homepageBack")
                            ) +
                            "\n                "
                        )
                      ])
                    ]
                  )
                : _c("li", { staticClass: "cat-headline" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("TuningFanatics::Template.catHeadline")
                      ) + ":"
                    )
                  ]),
              _vm._v(" "),
              _vm.dataContainer2.parent && _vm.dataContainer2.parent.id !== 659
                ? _c("li", { staticClass: "ddown" }, [
                    _c("a", { attrs: { href: _vm.parentUrl } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("TuningFanatics::Template.allProducts")
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function(category) {
                return _c(
                  "li",
                  {
                    staticClass: "ddown",
                    on: {
                      click: function($event) {
                        return _vm.slideTo(category)
                      }
                    }
                  },
                  [
                    _c("a", [_vm._v(_vm._s(category.details[0].name))]),
                    _vm._v(" "),
                    category.childCount
                      ? _c("span", { staticClass: "nav-direction" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "11",
                                height: "11"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M10.131 4.958a.556.556 0 0 1 .162.426.54.54 0 0 1-.162.408L5.427 10.08a.568.568 0 0 1-.79-.004.56.56 0 0 1 0-.795L8.92 5.375l-4.28-3.9a.56.56 0 0 1-.005-.8.565.565 0 0 1 .796.001l4.699 4.282zm-4.31.425a.538.538 0 0 1-.16.409L.955 10.079A.566.566 0 0 1 0 9.677c0-.15.06-.29.166-.397L4.45 5.375.17 1.475a.558.558 0 0 1-.005-.8.564.564 0 0 1 .795.001l4.7 4.282a.557.557 0 0 1 .16.425z",
                                  fill: "#31313a",
                                  "fill-rule": "evenodd"
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              }),
              _vm._v(" "),
              _vm.dataContainer2.categories[0]
                ? _vm._l(
                    _vm.dataContainer2.categories[0].siblingCount -
                      _vm.dataContainer2.categories.length,
                    function(number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" }
                        })
                      ])
                    }
                  )
                : _vm.dataContainer2.parent
                ? _vm._l(_vm.dataContainer2.parent.childCount, function(
                    number
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  })
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                on: {
                  click: function($event) {
                    return _vm.closeNavigation()
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("loading-animation")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }